import { Button } from "@amazing-care/ui/button";
import { MoonIcon, SunIcon } from "lucide-react";
import { useResolvedTheme, useThemeStore } from "@/stores/theme.store";

export function ThemeToggle() {
  const toggle = useThemeStore((state) => state.toggle);
  const resolved = useResolvedTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={resolved === "dark" ? "Switch to light theme" : "Switch to dark theme"}
    >
      {resolved === "dark" ? <MoonIcon className="size-4" /> : <SunIcon className="size-4" />}
    </Button>
  );
}
